module.exports = __webpack_public_path__ + "img/40040576.bdc4995a.jpg";